module.exports = __webpack_public_path__ + "static/media/auditoriumP.fc20aaf5.jpg";